import secureApi from "../services/secureApi";

export const getSizes = async ({ search = "", sort = "desc" } = {}) => {
  try {
    const params = { sort };

    if (search?.trim()) {
      params.search = search.trim();
    }

    const response = await secureApi.get("/admin/size/list", {
      params,
    });

    return response.data;
  } catch (error) {
    console.error("GET SIZE LIST ERROR", error);
    throw error;
  }
};

export const getSizeById = async (id) => {
  try {
    const response = await secureApi.get(`/admin/size/view/${id}`);
    return response.data;
  } catch (error) {
    console.error("GET SIZE DETAILS ERROR", error);
    throw error;
  }
};

export const getEditSize = async (id, data) => {
  try {
    const response = await secureApi.put(`/admin/size/edit/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("GET EDIT SIZE ERROR", error);
    throw error;
  }
};

export const addSize = async (data) => {
  try {
    const response = await secureApi.post("/admin/size/add", data);
    return response.data;
  } catch (error) {
    console.error("ADD SIZE ERROR", error);
    throw error;
  }
};

export const deleteSize = async (id) => {
  try {
    const response = await secureApi.delete(`/admin/size/delete/${id}`);
    return response.data;
  } catch (error) {
    console.error("DELETE SIZE ERROR", error);
    throw error;
  }
};